document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    // 寻找点击的目标是不是我们的色块（排除 +X 按钮）
    const swatch = event.target.closest('.ui-swatch:not(.ui-swatch--more)');
    if (!swatch) return;
    event.preventDefault();
    
    // 获取新图片链接

    const newImageUrl = swatch.getAttribute('data-image-url');
    console.log(newImageUrl,'--newImageUrl')
    // 找到当前商品卡片的最外层容器
    const cardContainer = swatch.closest('.product-card-wrapper');
    
    if (cardContainer && newImageUrl) {
      // 通过我们刚才添加的 custom-swatch-image-target 类名找到主图
      const mainImage = cardContainer.querySelector('.custom-swatch-image-target');
      
      if (mainImage) {
        // 关键步骤：因为 Shopify 原生用了 srcset，我们必须清空或者同时替换 srcset，否则浏览器不会更新图片
        mainImage.style.opacity = '0.8'; // 添加轻微的过渡动画反馈
        
        mainImage.setAttribute('srcset', newImageUrl); // 覆盖响应式属性
        mainImage.setAttribute('src', newImageUrl);    // 覆盖主属性
        
        // 图片加载完毕后恢复透明度
        mainImage.onload = () => {
          mainImage.style.opacity = '1';
        };
      }

      // 更新色块的高亮（黑圈）状态
      const wrapperList = swatch.closest('.custom-swatches-list');
      if (wrapperList) {
        wrapperList.querySelectorAll('.ui-swatch').forEach(btn => btn.classList.remove('is-active'));
        swatch.classList.add('is-active');
      }
    }
  });
});